import React, {useState, useEffect} from "react";
import Header from "../Components/Header/Header";
import BinStatus from "../Components/BinStatus/BinStatus";
import BinTable from "../Components/Tables/BinTable";
import { db } from "../firebase";
import {equalTo, onValue, ref, set, query, orderByChild, orderByValue, get } from 'firebase/database';
import Data from '../data'

export default BinManager => {
    const [numBinsCount, setNumBinsDataCount] = useState({
        binsActive: 0, 
        binsFilled:0,
        binsInactive:0,
    });

    const data = Data;

    
    const getBins = async () =>{
        const binRef = await ref(db, 'bins');
        onValue(binRef, (snapshot) => {
            const data = snapshot.val();
            // var activeBins = Object.keys(data).length
            var activeBins = Object.values(data).filter(bin => bin.status === 'active').length;
            var inactiveBins = Object.values(data).filter(bin => bin.status === 'Inactive').length;
            var filledBins = Object.values(data).filter(bin => bin.capacity >= 45).length;
            var closeToFillBins = Object.values(data).filter(bin => bin.capacity >= 70 && bin.capacity < 75).length;
            setNumBinsDataCount({
                binsActive: activeBins,
                binsFilled: filledBins,
                binsInactive: inactiveBins,
                binsCloseToFill: closeToFillBins,
            });
            // console.log(activeBins)
            // const filledBins = query(data, orderByChild('status'))
            console.log(closeToFillBins)
        })

    }
    
    useEffect(()=>{
        getBins()
    },[])
    
    
    return(
        <>
            <Header />
            <div className="mt-14">
                <BinStatus filledBins={numBinsCount.binsFilled} activeBins={numBinsCount.binsActive} brokenBins={numBinsCount.binsInactive}  closeToFill={numBinsCount.binsCloseToFill} />
            </div>
            <div className="mt-10">
                <BinTable />
            </div>
        </>
    )
}




// const uploadJSONToFirebase = (jsonData) => {
    //     // Replace 'data' with the desired node name where you want to store the JSON data in the database
    //     const databaseRef = ref(db, "/");
      
    //     // Upload the JSON data to the database
    //     set(databaseRef, data)
    //       .then(() => {
    //         console.log('JSON data uploaded successfully.');
    //       })
    //       .catch((error) => {
    //         console.error('Error uploading JSON data:', error);
    //       });
    //   };